var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-header",
    { staticStyle: { height: "64px" } },
    [
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "space-between" } },
        [
          _c("el-col", { attrs: { span: 16 } }, [_c("Breadcrumb")], 1),
          _c(
            "el-col",
            { staticClass: "right-header", attrs: { span: 4 } },
            [
              _c(
                "el-dropdown",
                {
                  directives: [
                    {
                      name: "intro",
                      rawName: "v-intro",
                      value: _vm.$t("Guide.header_guide01"),
                      expression: "$t('Guide.header_guide01')",
                    },
                    {
                      name: "intro-disable-interaction",
                      rawName: "v-intro-disable-interaction",
                      value: false,
                      expression: "false",
                    },
                  ],
                  attrs: { trigger: "click" },
                },
                [
                  _c("span", { staticClass: "el-dropdown-link" }, [
                    _c("img", { attrs: { src: _vm.checkThumb() } }),
                    _vm._v(_vm._s(_vm.user.name)),
                    _c("i", {
                      staticClass: "el-icon-arrow-down el-icon--right",
                    }),
                  ]),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _vm._l(_vm.submenusForUser(_vm.user), function (menu, i) {
                        return [
                          menu.line
                            ? [
                                _c(
                                  "el-dropdown-item",
                                  { attrs: { divided: "", index: String(i) } },
                                  [
                                    _c(
                                      "router-link",
                                      { attrs: { to: { path: menu.path } } },
                                      [_vm._v(_vm._s(_vm.$t(menu.name)))]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : [
                                _c(
                                  "el-dropdown-item",
                                  { attrs: { index: String(i) } },
                                  [
                                    _c(
                                      "router-link",
                                      { attrs: { to: { path: menu.path } } },
                                      [_vm._v(_vm._s(_vm.$t(menu.name)))]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                        ]
                      }),
                      _c(
                        "el-dropdown-item",
                        { attrs: { divided: "" } },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: { to: { path: "/sign_in" } },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.signOut.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("submenus.logout")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }